import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/receipts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/receipts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/receipts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const previewPDF = id => {
  return httpClient
    .get(`/api/receipts/generate-pdf/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentReceipt = (Options = {}) => {
  return httpClient
    .get('/api/receipts/students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/receipts/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  previewPDF,
  studentReceipt,
  formViewModel
}
